<template>
  <div>
    <DxPopup
      :visible="visible"
      :close-on-outside-click="false"
      :show-close-button="true"
      class="DxPopup popUp-custom"
      :wrapper-attr="{ class: 'albaran-popup' }"
      width="730"
      height="auto"
      :title-template="'customTitle'"
      container=".dx-viewport"
      @hiding="$emit('close')"
    >
      <template #customTitle>
        <div class="custom-popup-title">
          <div class="popup-icon">
            <div class="icon-bg"></div>
            <div class="icon-flask"></div>
            <div class="icon-check"></div>
          </div>
        </div>
      </template>
      <div class="popup-content">
        <h2 class="popup-title">
          {{ $t('PopUpConfimationRegister.CorrectUpdate') }}
        </h2>
        <h2 class="popup-subTitle">
          {{ code }}
        </h2>
        <div class="popup-actions">
          <f7-button
            class="btn-accept"
            fill
            outline
            type="default"
            @click="$emit('close')"
          >
            {{ $t('samplesRegister.ok') }}
          </f7-button>
        </div>
      </div>
    </DxPopup>
  </div>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup';

export default {
  components: {
    DxPopup,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    code: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.custom-popup-title {
  background: transparent;
  padding: 24px 10px 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup-icon {
  position: relative;
  width: 100px;
  height: 100px;
}

.icon-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-image: url('@/static/icons/Ellipse 3.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 1;
}

.icon-flask {
  position: absolute;
  top: 18%;
  left: 18%;
  width: 65%;
  height: 65%;
  background-image: url('@/static/icons/erlenmeyer-flask--science-experiment-lab-flask-chemistry-solution.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 2;
}

.icon-check {
  position: absolute;
  top: 0;
  right: 0;
  width: 30%;
  height: 30%;
  background-image: url('@/static/icons/check.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 3;
}

.popup-content {
  padding: 15px 25px 25px 25px;
  text-align: center;
  font-family: 'Arial', sans-serif;
  padding-top: 0;
}

.popup-title {
  color: var(--Neutral-70, #3e3c44);
  font-size: 16px;
  font-style: normal;
  margin-bottom: 15px;
  font-weight: 400;
  line-height: 140%;
}

.popup-subTitle {
  font-size: 1.2rem;
  margin-bottom: 20px;
  color: var(--Neutral-70, #3e3c44);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
}

.popup-actions {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.btn-accept {
  color: white;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  width: auto;
  padding: 16px;
  padding-top: 3px;
}

.btn-accept:hover {
  background: #00346a;
  transform: scale(1.05);
}

.dx-popup-title {
  border-bottom: none !important;
}

.albaran-popup
  .dx-overlay-content.dx-popup-normal.dx-resizable.dx-popup-flex-height {
  width: 730px !important;
}

.albaran-popup .dx-overlay-content {
  width: 730px !important;
}
</style>
